import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'

export function NotFoundPage() {
  return (
    <div className="flex w-full flex-col items-center gap-4 py-20 text-center">
      <p className="text-sm font-semibold text-biddle-blue">404</p>
      <h1 className="text-3xl font-bold text-navy">Page not found</h1>
      <p className="text-sm text-muted">
        That link doesn’t match anything in Biddle. Head back to search and try again.
      </p>
      <Button asChild variant="primary">
        <Link to="/search">Back to search</Link>
      </Button>
    </div>
  )
}
